import Konva from 'konva';

export function getPointerPosition(stageRef: React.RefObject<Konva.Stage>) {
  let result = {x: 0, y: 0};
  const stage = stageRef.current;
  const pointerPosition = stage?.getPointerPosition();

  if (stage && pointerPosition) {
    result = {
      x: pointerPosition.x,
      y: pointerPosition.y,
    };
  }

  return result;
}

export function getAnchorPointUnderClick(event: Konva.KonvaEventObject<MouseEvent>) {
  let element: Konva.Node | null = null;
  const stage = event.target.getStage();

  if (stage) {
    const pointerPos = stage.getPointerPosition();

    if (pointerPos) {
      const elements = stage.getAllIntersections(pointerPos);

      if (elements) {
        const anchorPoint = elements.find(element => element.hasName('anchor-point'));

        element = anchorPoint ?? null;
      }
    }
  }

  return element;
}
